import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import { formatAmount } from "../../helpers/common";
import { GETREQUEST } from "../../helpers/ServiceRequest";

function Containers() {
  const [containers, setContainers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [current, setCurrent] = useState("");
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [sortColumn, setSortColumn] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);
  const [SearchContainerCode, setSearchContainerCode] = useState("");
  const [SearchContainerDesc, setSearchContainerDesc] = useState("");
  const [searchContainerValue, setSearchContainerValue] = useState("");
  const [searchReturnValue, setSearchReturnValue] = useState("");
  const { user } = useAuth();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let queryParams = [];

      let URL = process.env.REACT_APP_API_URL + `/get-containers?page=${page}&size=${size}`;
      if (SearchContainerCode) queryParams.push(`searchContainerCode=${SearchContainerCode}`);
      if (SearchContainerDesc) queryParams.push(`searchContainerDesc=${SearchContainerDesc}`);
      if (searchContainerValue) queryParams.push(`searchContainerValue=${searchContainerValue}`);
      if (searchReturnValue) queryParams.push(`searchReturnValue=${searchReturnValue}`);
      if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);
      if (current) queryParams.push(`current=${current}`);

      if (queryParams.length > 0) URL += `&${queryParams.join('&')}`;

      // if(current != "" && searchText != ""){
      //   URL = URL + `&current=${current}&searchText=${searchText}`;
      // }else if(current != ""){
      //   URL = URL + `&current=${current}`;
      // } else if(searchText != ""){
      //   URL = URL + `&searchText=${searchText}`;
      // }
      let response = await GETREQUEST(URL, user.jwtToken, false);
      if (response?.data) {
        setLoading(false);
        const containersList = response.data.data;
        containersList.sort((a, b) => {
          const numA = parseInt(a.ContainerCode);
          const numB = parseInt(b.ContainerCode);

          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          } else if (!isNaN(numA)) {
            return -1;
          } else if (!isNaN(numB)) {
            return 1;
          } else {
            return a.ContainerCode.localeCompare(b.ContainerCode);
          }
        });
        setContainers(containersList);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setCurrentPage(response.data.currentPage)
      }
    }
    fetchData();
  }, [searchText, current, page, sortBy, sortColumn, SearchContainerCode, SearchContainerDesc, searchContainerValue, searchReturnValue]);
  const handleSort = (sortName) => {
    setSortColumn(sortName);
    if (sortBy == "")
      setSortBy("ASC")
    else if (sortBy == "ASC")
      setSortBy("DESC")
    else
      setSortBy("ASC")
  }
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight - 20 + "px");
  });

  const getStartPageIndex = () => {
    return page === 0 ? 1 : page * size + 1;
  };

  const getEndPageIndex = () => {
    if (page === 0) {
      return containers.length;
    }
    const endIndex = (page + 1) * size;
    return endIndex > totalItems ? totalItems : endIndex;
  };

  return (
    <React.Fragment>
      <Header />
      <main>
        <section className="p-4 overflow-hidden table-listing">
          <div className="table-elements">
            <div className="paginations d-flex align-items-center p-2">
              <p className="fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-1">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className={`bi bi-chevron-left text-light`}></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
              <div style={{ marginLeft: "10px" }}>
                <select
                  className="form-select input-sm cme-10"
                  aria-label="Page size select example"
                  style={{ width: "100px" }}
                  value={size}
                  onChange={(e) => { setSize(e.target.value); setPage(0) }}
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-center align-items-start justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Containers
              </h1>
              <div className="filter-elements d-flex align-items-center">
                {/* <div className="input-group flex-nowrap cme-20 me-0">
                  <div
                    type="button"
                    className="btn btn-outline-light hover-none border-end-0 d-flex align-items-center pe-0"
                  >
                    <i className="bi bi-search"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control input-sm border-start-0 search"
                    placeholder="Search by Container Description"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div> */}
                <div className="custom-group flex-nowrap">
                  <Link
                    to="/create-container"
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i>Add Container
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body p-0 border-bottom ">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="width-lg-4 width-sm-auto">
                        {/* Container Code */}
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('ContainerCode')}>Container Code</span>
                          {sortColumn == "ContainerCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-40 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Container Code"
                            onChange={(e) => setSearchContainerCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col">
                        {/* Container Description */}
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('ContainerDesc')}>Container Description</span>
                          {sortColumn == "ContainerDesc" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-40 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Container Description"
                            onChange={(e) => setSearchContainerDesc(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-9 width-sm-auto">
                        {/* Container Value */}
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('ContainerValue')}>Container Value</span>
                          {sortColumn == "ContainerValue" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Container Value"
                            onChange={(e) => setSearchContainerValue(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-9 width-sm-auto">
                        {/* Return Value */}
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('ReturnValue')}>Return Value</span>
                          {sortColumn == "ReturnValue" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Return Value"
                            onChange={(e) => setSearchReturnValue(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-9 width-sm-auto">
                        {/* Status */}
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('Current')}>Status</span>
                          {sortColumn == "Current" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="p-1">
                          <select
                            className="form-select input-sm cme-10"
                            aria-label="Default select example"
                            style={{ width: "168px" }}
                            onChange={(e) => setCurrent(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </select>
                        </div>
                      </th>
                      <th scope="col" className="width-lg-5 width-sm-auto">
                        <span style={{ position: "absolute", top: "22px" }}>Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {containers.length == 0 && (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {containers.map((container, index) => {
                      return (
                        <tr key={index}>
                          <td>{container.ContainerCode}</td>
                          <td>{container.ContainerDesc}</td>
                          <td>{formatAmount(container.ContainerValue)}</td>
                          <td>{formatAmount(container.ReturnValue)}</td>
                          <td>
                            <span
                              className={
                                "badge statusBadge border  fw-medium  px-4 fs-13 cpy-7 " +
                                (container.Current === 1
                                  ? "border-success text-success bg-success-lite"
                                  : "border-warning text-warning bg-warning-lite")
                              }
                            >
                              {container.Current === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link
                              to={"/update-container/" + container.ContainerID}
                              className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                            >
                              View/Edit
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default Containers;
